import React, { Suspense } from "react";
import { Await, defer, json, useLoaderData } from "react-router-dom";
import { getSystemMailById } from "../../api/systemMailClient";
import SystemMailTemplateEditor from "../../components/SystemMail/SystemMailTemplateEditor";
import { SystemMail } from "../../model/SystemMail";
import { CircularProgress } from "@mui/material";

const EditSystemMailTemplatePage: React.FC = () => {
    const { template } = useLoaderData() as { template: Promise<SystemMail> };

    return (
        <Suspense fallback={<CircularProgress />}>
            <Await resolve={template}>
                {(templateData) => (
                    <SystemMailTemplateEditor
                        method="PUT"
                        template={templateData}
                    />
                )}
            </Await>
        </Suspense>
    );
};

export default EditSystemMailTemplatePage;

async function loadTemplate(templateId: string, customerId: string) {
    try {
        return await getSystemMailById(templateId, customerId);
    } catch {
        throw json(
            { message: "Could not fetch system mail template." },
            { status: 500 }
        );
    }
}

export async function loader({
    params,
}: {
    request: Request;
    params: { customerId: string; templateId: string };
}) {
    const { customerId, templateId } = params;
    return defer({
        template: loadTemplate(templateId, customerId),
    });
}
